import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { AdvertisementDetailsComponent } from '../pages/advertisement-details/advertisement-details.component';

@Component({
  selector: 'app-representative-address-list',
  templateUrl: './representative-address-list.component.html',
  styleUrls: ['./representative-address-list.component.scss']
})
export class RepresentativeAddressListComponent {
  Address:  any[]=  [];
  issuenamenew: string;
  cust_name: string;
  issuedatepp: Date;
  start_date: any;
  end_date: any;
  val: any;
  district: string;
  advt_name: string;
  rep_name: string;
  off_rep_name: string;
  issue_category: string;
  issue_date: string;
  issue_name: string;
  today: Date = new Date();
  currentDate: Date = new Date();
  issueSellerName: any;

  constructor(
    private dialogRef: MatDialogRef<RepresentativeAddressListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    debugger
    this.issuenamenew = this.data['issuenamenew'];
    this.cust_name = this.data['cust_name'];
    this.issuedatepp = this.data['issuedatepp'];
    this.start_date = this.data['start_date'];
    this.end_date = this.data['end_date'];
    this.val = this.data['val'];
    this.district = this.data['district'];
    this.advt_name = this.data['advt_name'] || '';
    this.rep_name = this.data['rep_name'] || '';
    this.off_rep_name = this.data['off_rep_name'] || '';
    this.issue_category = this.data['issue_category'] || '';
    this.issue_date = this.data['issue_date'] || '';


    // public Address: any[] = [];


    if (this.issue_date.includes(',')) {
      [this.issue_date, this.issue_name] = this.issue_date.split(',');
    }


     const req: any = {
      "rep_name":  this.rep_name,
      "start_date": this.start_date,
      "end_date": this.end_date,
      "off_rep_name": this.off_rep_name,
      "advt_name": this.data['name'],
      "issue_name": this.issue_category,
      "issue_date": this.issue_date


    }

    debugger
    this.service.getRepNameList(req).subscribe((data:any) => {
      debugger
      this.Address = data;
    });
  }
  print() {
    const originalTitle = document.title; // Store original title
    document.title = '';     // Set custom print title
  
    // Create a style tag for print-specific styles
    const style = document.createElement('style');
    style.innerHTML = `
      @media print {
        @page {
          size: A4;
          margin: 20mm;
        }
        .print-header {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .print-footer {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 12px;
          color: gray;
        }
        .print-footer::after {
          content: "Page " counter(page) " of " counter(pages);
        }
        .no-print {
          display: none !important;
        }
      }
    `;
  
    document.head.appendChild(style); // Add style to the document
  
    setTimeout(() => {
      const printTrigger = document.getElementById('print-button');
      if (printTrigger) (printTrigger as HTMLElement).click();
      
      document.title = ''; // Restore original title after printing
      
      // document.head.removeChild(style); // Remove the style after printing
    }, 500); // Delay ensures styles apply before printing
  }
}

 

